

<template>
    <div>
        <div class="dubl_currinces mb-5">
            <div class="" >
                <yes_no
                    key="SHOW_DOUBLE_CURRENCY"
                    title="SHOW_DOUBLE_CURRENCY"
                    v-model="show_double_currency"
                >
                </yes_no>
            </div>
        </div>

        <div >
            <div class="form-group mt-2">
                <label class="form-label" for="wcssurrency">
                    {{__t("WOLT_CURRENCIES")}}*
                </label>

                <div class="" v-if="currencies.length > 0">
                    <v-select v-model="active_currency"
                              class="imc_reasons"
                              label="name"
                              key="w_curency"
                              :options="this.currencies"
                              :filterable="false"
                              :clearable="false"
                    >
                        <template slot="no-options">
                            {{__t("CHOICE_CURENCY")}}
                        </template>

                    </v-select>
                </div>
            </div>


            <div class="form-group mt-2">
                <label class="form-label" for="pwa.default_geo_radius">
                    {{__t('pwa.cross_currency')}}
                </label>

                <div class="input-group flex-nowrap">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="fal fa-address-book  fs-xl" ></i>
                        </span>
                    </div>

                    <b-form-input
                        class="form-control"
                        id="pwa.default_geo_radius"
                        v-model="pwa.double_currency.cross_currency"
                    >
                    </b-form-input>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
import yes_no from "../../../../../sys/radio/yes_no.vue";
import vSelect from 'vue-select'
export default {
    name: "pwa_double_currency_tab",
    components: {yes_no,vSelect},
    props : {
        pwa : {
            type:Object
        }
    },
    data() {
        return {
            currencies : [],
        }
    },

    created() {
        this.load_currencies();
    },

    methods : {
        async load_currencies() {
            await api.get('/api/v2/currencies',{}).then(({data}) => {
                if (data.status === "operation_success") {
                    this.currencies = data.data;
                }

            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    },

    computed : {
        show_double_currency : {
            get()  {
                return this.pwa.double_currency.has_double_currency;
            },
            set(val)  {
                this.pwa.double_currency.has_double_currency = val;
            }
        },

        active_currency : {
            get :function () {
                let active = null;
                if(this.currencies.length > 0) {
                    if(this.pwa.hasOwnProperty("double_currency")) {
                        this.currencies.map(item => {
                            if(parseInt(item.id) === parseInt(this.pwa.double_currency.double_currency_id)) {
                                active = item;
                            }
                        })
                    }
                }

                return active;
            },

            set: function (val){
                if(val != null) {
                    if (this.pwa.hasOwnProperty("double_currency")) {
                        this.pwa.double_currency.double_currency_id = val.id;
                    }
                }
                else {
                    this.pwa.double_currency.double_currency_id = 0;
                }
            },
        },

    }

}
</script>


<style scoped>

</style>
